import { Button, Typography } from "@mui/material";
import PopUpConsent from "../Authentication/PopUpConsent";
import { useState } from "react";
import HelpIcon from "@mui/icons-material/Help";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import pdffile from "../../pdf/מדריך פורטל לקוחות.pdf";

const Footer = () => {
  const [openPopUp, setOpenPopUp] = useState(false);

  const closePopup = (value) => {
    setOpenPopUp(value);
  };

  const openPdf = () => {
    window.open(pdffile, "_blank");
  };

  const openVideoGuide = () => {
    window.open('/guideline-video', '_blank');
  };

  return (
    <footer
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="caption"
        sx={{ marginTop: "1.5rem", marginRight: "4rem" }}
      >
        © כל הזכויות שמורות לניאופרם בע"מ. שימוש בפורטל זה כפוף לתנאי השימוש
        <Button
          style={{ textDecoration: "underline", fontSize: "12px" }}
          onClick={() => setOpenPopUp(true)}
        >
          תנאי השימוש
        </Button>
      </Typography>
      <Button
        startIcon={<HelpIcon />}
        onClick={openPdf}
        style={{
          fontSize: "12px",
          marginTop: "1.5rem",
        }}
      >
        מדריך משתמש
      </Button>
      <Button
        startIcon={<VideoLibraryIcon />}
        onClick={openVideoGuide}
        style={{
          fontSize: "12px",
          marginTop: "1.5rem",
          marginLeft: "1rem",
        }}
      >
        מדריך וידאו
      </Button>
      <PopUpConsent openPopUp={openPopUp} closePopup={closePopup} />
    </footer>
  );
};

export default Footer;
